// extracted by mini-css-extract-plugin
export default {"header":"KSVA1z","hidden":"ENJPpt"};